module.exports = __webpack_public_path__ + "static/media/shila_thumb_wide.4dc61c54.jpg";